import { Transacao } from '../../servicos/transacoes/typeTransacao';

/** Soma valores de um tipo ('R' receitas | 'D' despesas). */
export const somarPorTipo = (lista: Transacao[], tipo: 'R' | 'D'): number =>
  lista
    .filter((transacao) => transacao.tipo === tipo)
    .reduce((total, transacao) => total + Number(transacao.valor), 0);

/** Delta percentual vs período anterior ("+12%", "-5%"); sem base, sem delta. */
export const montarDelta = (atual: number, anterior: number): string | undefined => {
  if (anterior <= 0) return undefined;
  const variacao = Math.round(((atual - anterior) / anterior) * 100);
  return `${variacao >= 0 ? '+' : ''}${variacao}%`;
};

/** Tom do delta: subir receita é bom, subir despesa é ruim. */
export const tomDelta = (atual: number, anterior: number, subirEhBom: boolean): 'bom' | 'ruim' | 'neutro' => {
  if (anterior <= 0 || atual === anterior) return 'neutro';
  return (atual > anterior) === subirEhBom ? 'bom' : 'ruim';
};

/** Projeção de fim de mês pelo ritmo atual de gasto (run-rate). */
export const projetarFimDeMes = (gastoAteAgora: number, diasDecorridos: number, diasDoMes: number): number =>
  diasDecorridos > 0 ? (gastoAteAgora / diasDecorridos) * diasDoMes : 0;
